<template>
  <button
    class="container-button"
    :class="!disabled ? 'container-enabled' : false"
    :style="styled"
    @click="!disabled ? $emit('click') : null"
  >
    <feather
      v-if="!isLoading"
      :type="icon.type"
      :size="icon.size"
      :style="`color: ${icon.color};`"
    />
    <div v-else class="loader-icon" />

    <span class="title-kbutton">{{ title }}</span>
  </button>
</template>

<script>
export default {
	name: 'DefaultButton',
	props: {
		isLoading: {
			type: Boolean,
			default: false,
		},
		icon: {
			type: Object,
			default: () => ({
				type: 'filter',
				size: '14px',
				color: '#000000',
			}),
		},
		borderDisabled: {
			type: Boolean,
			default: false,
		},
		title: {
			type: String,
			default: 'Filtros',
		},
		fontSize: {
			type: String,
			default: '12px',
		},
		backgroundColor: {
			type: String,
			default: '#FFF',
		},
		marginLeft: {
			type: String,
			default: '0px',
		},
		marginRight: {
			type: String,
			default: '0px',
		},
		borderRadius: {
			type: String,
			default: '10px',
		},
		width: {
			type: String,
			default: '100px',
		},
		height: {
			type: String,
			default: '30px',
		},
		borderWidth: {
			type: String,
			default: '1px',
		},
		borderStyle: {
			type: String,
			default: 'solid',
		},
		borderColor: {
			type: String,
			default: '#cecece',
		},
		letterSpacing: {
			type: String,
			default: '0',
		},
		display: {
			type: String,
			default: 'flex',
		},
		alignItems: {
			type: String,
			default: 'center',
		},
		justifyContent: {
			type: String,
			default: 'center',
		},
		fontFamily: {
			type: String,
			default: 'Sora, sans-serif !important',
		},
		fontWeight: {
			type: String,
			default: 'bold',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		titleColor: {
			type: String,
			default: '#000000',
		},
	},
	data() {
		return {};
	},
	computed: {
		styled() {
			return {
				'--icon-size': this.icon.size,
				fontSize: this.fontSize,
				backgroundColor: this.backgroundColor,
				borderRadius: this.borderRadius,
				color: this.titleColor,
				width: this.width,
				height: this.height,
				borderWidth: !this.borderDisabled ? this.borderWidth : '0px',
				borderStyle: this.borderStyle,
				borderColor: this.borderColor,
				display: this.display,
				alignItems: this.alignItems,
				fontFamily: this.fontFamily,
				fontWeight: this.fontWeight,
				justifyContent: this.justifyContent,
				letterSpacing: this.letterSpacing,
				marginLeft: this.marginLeft,
				marginRight: this.marginRight,
			};
		},
	},
	methods: {
		sendEmit() {
			this.$emit('button-click');
		},
	},
};
</script>

<style scoped lang="scss">
.title-kbutton {
	margin-left: 5px;
}
button {
	all: unset;
}
.container-button {
	transition: 150ms ease-in-out;
	cursor: pointer;
	padding-right: 7px;
	padding-left: 7px;
}
.loader-icon {
	animation: is-rotating 1s infinite;
	border: 2px solid #cecece;
	width: calc(var(--icon-size) - 4px);
	border-top-color: #ff3b30;
	border-radius: 50%;
	height: calc(var(--icon-size) - 4px);
}

@keyframes is-rotating {
	to {
		transform: rotate(1turn);
	}
}
</style>
